import { Injectable } from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoPaymentService {

  constructor(
      private _rest: NeoRestService
  ) { }

    /**
     * Añade un pago
     *
     * @param orderId
     * @param payment
     * @return Un objeto observable
     * */
    addPayment(orderId, payment) {
        return this._rest.postRaw(`/payment/${orderId}`, payment);
    }

    /**
     * Modifica un pago
     *
     * @param paymentId
     * @param payment
     * @return Un objeto observable
     * */
    updatePayment(paymentId, payment) {
        return this._rest.putRaw(`/payment/${paymentId}`, payment);
    }

    /**
     * Elimina un pago
     *
     * @param paymentId Id del pago
     * @return Un objeto observable
     * */
    removePayment(paymentId) {
        return this._rest.delete(`/payment/${paymentId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-payment/neo-payment.service.ts